module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOBAMAAAC88gOBAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9kKFhYGAf/Rv3cAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAFVBMVEX4gHhIQDhwWEiAeHCoqHj4+Pj///9Z170jAAAAAXRSTlMAQObYZgAAAAFiS0dEBmFmuH0AAABbSURBVAjXY2BxQQEODE5KKECFQQkNAAVUQ42UQo2ApKpRMETAOBiKTI0gAkbBUBSshCwA0oIQCAWpR1aBakaoMVSXMcQWZWMjZSNjCAILoDlMCJWvyMAoiAIEACYoJguH2ZpvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/types/Dark.png
// module id = 158
// module chunks = 0